import React from "react";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import EulaBCP from "./eula/EulaBCP";
const COMPANY_FLAG = getEnvironmentVariable("COMPANY_FLAG");

// bcp styling
// const EulaBCP = React.lazy(() => import("./eula/EulaBCP"));

// const Eula = () => (
//   <>
//     {/* Conditionally render theme, based on the current client context */}
//     <React.Suspense fallback={() => null}>
//       {COMPANY_FLAG === "bcp" && <EulaBCP />}
//       {COMPANY_FLAG !== "bcp" && <EulaBCP />}
//     </React.Suspense>
//   </>
// );

export default function Eula() {
  if (COMPANY_FLAG !== "bcp") {
    // return custom eula
  }
  return <EulaBCP />;
}
